import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ArtifactTemplateLibrary } from './ArtifactTemplateLibrary';
import { ArtifactTemplate } from './artifactTemplatesData';
import {
  setAdvancedMode,
  setArtifactsViewActive,
  setPendingInputText,
} from '../../../aiAgentCenter/agentsHomeReducer';
import { AgentInputMode } from '../../../aiAgentCenter/agent-input/agentInputModeTypes';
import useAgentsChats from '../../../aiAgentCenter/useAgentsChats';
import { AiAgent } from '../../../aiAgentCenter/aiAgentsConsts';

interface BuiltBySweepTabProps {
  activeAgent: AiAgent;
}

export const BuiltBySweepTab = ({ activeAgent }: BuiltBySweepTabProps) => {
  const dispatch = useDispatch();
  const { setAgentClickHandler } = useAgentsChats();

  const handleUseTemplate = useCallback(
    (template: ArtifactTemplate) => {
      // Set the pending input text with the template prompt
      dispatch(setPendingInputText(template.prompt));
      // Enable artifact mode
      dispatch(setAdvancedMode({ advancedMode: AgentInputMode.ArtifactMode }));
      // Close artifacts view
      dispatch(setArtifactsViewActive(false));
      // Navigate to agent (new chat)
      setAgentClickHandler({ agent: activeAgent });
    },
    [dispatch, setAgentClickHandler, activeAgent],
  );

  return <ArtifactTemplateLibrary onUseTemplate={handleUseTemplate} />;
};
